import axios          from "axios";
import config         from "../config/config"
import {FeatureTypes} from "@/util/enums/FeatureTypes";

export default class Features {
    public static async getFeatures(extent: Array<number>, type: FeatureTypes) {
        return await axios.get(config.API_URL + '/v1/features', {
                params: {
                    extent: extent,
                    type  : type,
                }
            }
        )
    }
}